module.exports = __webpack_public_path__ + "static/media/kOpZ4PZFplVaKEBh3zBjSqCuf7KYRKNyZWFSVyKA.0f4ae698.webp";